import { Dispatch } from 'redux'

import { SelectOptionLocal } from '../../../types/common/commonTypes'
import { apiInstance } from '../../api/apiInstance'
import { storeDispatchTypes } from '../../store/storeDispatchTypes'

const getAllCoversBrands =
    (searchTerm: string, typeId?: string) =>
    async (dispatch: Dispatch): Promise<void> => {
        dispatch({ type: storeDispatchTypes.setPartsLoader, value: { field: 'coversBrands', value: true } })

        try {
            const {
                data: { status, data },
            } = await apiInstance.post('/dicts/avito/CoversBrands', { typeId })
            const coversBrands: SelectOptionLocal[] = []

            if (status === 'ok') {
                const parser = new DOMParser()
                const xmlDoc = parser.parseFromString(data, 'text/xml')
                const brandsNodes = xmlDoc.getElementsByTagName('Brand')

                for (let i = 0; i < brandsNodes.length; i++) {
                    const brandName = brandsNodes[i].textContent?.trim()
                    if (brandName && brandName.toLocaleLowerCase().includes(searchTerm.toLocaleLowerCase())) {
                        coversBrands.push({ name: brandName, value: brandName })
                    }
                }
            }
            dispatch({ type: storeDispatchTypes.setAllCoversBrands, value: { coversBrands } })
        } catch (e) {
            console.error('load coversBrands failed', e)
        }

        dispatch({ type: storeDispatchTypes.setPartsLoader, value: { field: 'coversBrands', value: false } })
    }

export default getAllCoversBrands
